import { render, staticRenderFns } from "./NewItemSearchCard.vue?vue&type=template&id=28b22006&scoped=true"
import script from "./NewItemSearchCard.vue?vue&type=script&lang=js"
export * from "./NewItemSearchCard.vue?vue&type=script&lang=js"
import style0 from "./NewItemSearchCard.vue?vue&type=style&index=0&id=28b22006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b22006",
  null
  
)

export default component.exports